import React from 'react';
import { Section } from './ui/Section';
import { CheckCircleIcon, XCircleIcon } from 'lucide-react';
export function ForWhoSection() {
  return <Section className="bg-navy-900" dark={true} data-id="element-91">
      <div className="grid md:grid-cols-2 gap-12 max-w-5xl mx-auto" data-id="element-92">
        {/* For You */}
        <div className="space-y-8" data-id="element-93">
          <h3 className="text-2xl font-serif text-gold-400 flex items-center gap-3" data-id="element-94">
            <CheckCircleIcon className="w-6 h-6" data-id="element-95" />
            This is for you if:
          </h3>
          <ul className="space-y-4" data-id="element-96">
            {["You're 40+ and your mind races at night", 'You wake up at 2–4am and struggle to return to sleep', "You're tired of vague advice and want a simple method", 'You want a natural approach that still feels practical'].map((item, i) => <li key={i} className="flex gap-4 text-cream-100/80" data-id="element-97">
                <span className="w-1.5 h-1.5 rounded-full bg-gold-400 mt-2.5 flex-shrink-0" data-id="element-98" />
                <span data-id="element-99">{item}</span>
              </li>)}
          </ul>
        </div>

        {/* Not For You */}
        <div className="space-y-8 md:border-l md:border-navy-700 md:pl-12" data-id="element-100">
          <h3 className="text-2xl font-serif text-cream-500 flex items-center gap-3 opacity-70" data-id="element-101">
            <XCircleIcon className="w-6 h-6" data-id="element-102" />
            This is not for you if:
          </h3>
          <ul className="space-y-4" data-id="element-103">
            {['You need medical treatment for severe insomnia without professional support', "You suspect sleep apnea and won't get evaluated", "You want a one-step 'knockout' solution"].map((item, i) => <li key={i} className="flex gap-4 text-cream-100/50" data-id="element-104">
                <span className="w-1.5 h-1.5 rounded-full bg-navy-600 mt-2.5 flex-shrink-0" data-id="element-105" />
                <span data-id="element-106">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </Section>;
}